import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './styles/global.scss';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);
root.render(
    <React.StrictMode>
        <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_ISSUER_BASE_URL as string}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID as string}
            authorizationParams={{
                audience: process.env.REACT_APP_AUTH0_AUDIENCE as string,
                redirect_uri: window.location.origin
            }}
            cacheLocation="localstorage"
            useRefreshTokens={true}
            // Restore the URL saved by the login button; the app reads its
            // params only after Auth0 finishes, so this runs in time
            onRedirectCallback={(appState) => {
                window.history.replaceState({}, document.title, appState?.returnTo || window.location.pathname);
            }}
        >
            <App />
        </Auth0Provider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
